import React, { useState, useEffect, useCallback } from "react";
import "../Styles/style.css";
import axios from "axios";
import Sidebar from "./sideBar";
import AdsResult from "./adsResult";
import { baseUrl } from "../../api/ipconfig";
import Pagination from "@mui/material/Pagination";
import { Link, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function SearchResult() {
  const [vehicleCategory, setVehicleCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const [isSticky, setSticky] = useState(false);

  const queryParams = new URLSearchParams(location.search);
  const selectedAdType = queryParams.get("postType");
  const selectedBodyType = queryParams.get("bodytype");
  const selectedMake = queryParams.get("make");
  const selectedModel = queryParams.get("model");
  const selectedYear = queryParams.get("year");
  const selectedCity = queryParams.get("city");
  const selectedCategories = queryParams.get("category");
  const selectedCondition = queryParams.get("cnd");
  const selectedMinPrice = queryParams.get("mnp");
  const selectedMaxPrice = queryParams.get("mxp");
  const searchData = queryParams.get("keyword");
  const selectedTransmission = queryParams.get("transmission");
  const selectedFuelType = queryParams.get("fuelType");

  const [filters, setFilters] = useState({
    search: null,
    condition: "used",
    city: 0,
    make: 0,
    model: 0,
    year: 0,
    minPrice: 0,
    maxPrice: 50000000,
    category: 0,
    postType: "",
    transmission: "",
    bodytype: "",
  });

  const [postData, setPostData] = useState([]);
  const [featuredData, setFeaturedData] = useState([]);

  const searchCategory = selectedCategories;

  const searchAdType = selectedAdType;
  const searchBodyType = selectedBodyType;
  const searchMake = selectedMake;
  const searchModel = selectedModel;
  const searchYear = selectedYear;

  const searchCity = selectedCity;

  const searchCondition = selectedCondition;
  const searchMaxPrice = selectedMaxPrice;
  const searchMinPrice = selectedMinPrice;
  const searchTransmission = selectedTransmission;
  const searchFuelType = selectedFuelType;

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 250);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const response = await axios.get(`${baseUrl}/bycategory`);
        setVehicleCategory(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchFilters();
  }, []);

  const handleCategoryChange = (category) => {
    setSelectedCategory(category);
  };

  const handleFilterChange = (filterName, value) => {
    setPage(1);
    setFilters((prevFilters) => ({
      ...prevFilters,
      [filterName]: value,
    }));
  };

  const handleRecall = () => {};

  const [page, setPage] = React.useState(1);
  const [totalPages, setTotalPages] = React.useState(0);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const user = localStorage.getItem("data");
  const userId = JSON.parse(user)?.id;

  const [freeAdCount, setFreeAdCount] = useState("");

  const fetchData = useCallback(
    async (filters, page) => {
      try {
        setLoading(true);
        const category = filters.category || searchCategory || 0;
        const search = filters.search || searchData || " ";
        const bodytype = filters.bodytype || [searchBodyType] || "";
        const make = filters.make || [searchMake] || 0;
        const model = filters.model || [searchModel] || [];
        const year = filters.year || [searchYear] || [];
        const mileage = filters.mileage || 0;
        const transmission = filters.transmission || searchTransmission;
        const fuel = filters.fuel || searchFuelType;
        const minPrice = filters.minPrice || searchMinPrice;
        const maxPrice = filters.maxPrice || searchMaxPrice;
        const postType =
          filters.postType || (searchAdType === "featured" ? 2 : 0);
        let city = filters.city !== 0 ? filters.city : searchCity;
        let cityParams = {};
        if (city) {
          cityParams["city_name[]"] = city; // Correct format
        }

        const response = await axios.get(`${baseUrl}/webfilterpost`, {
          params: {
            page: page,
            search_name: search,
            ...cityParams,
            body_type: bodytype,
            makeName: make,
            modelName: model,
            year_id: year,
            price_from: minPrice,
            price_to: maxPrice,
            engine_capacity: category,
            mileage: mileage,
            transmission: transmission,
            fuel_type: fuel,
            post_type_id: postType,
            condition: "used",
          },
        });

        setPostData(response?.data?.posts?.data);
        setFeaturedData(response?.data?.featured_adds?.data);
        setFreeAdCount(response?.data?.addcount);
        setTotalPages(response?.data?.posts?.last_page);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    },
    [
      searchCategory,
      searchMake,
      searchCity,
      searchCondition,
      userId,
      searchData,
      searchAdType,
    ]
  );

  useEffect(() => {
    fetchData(filters, page);
  }, [filters, page]);

  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error("Adsbygoogle error: ", e);
      // alert(e);
    }
  }, []);

  useEffect(() => {
    if (!window.googletag) {
      console.error("Google Publisher Tag (GPT) is not loaded.");
      return;
    }

    window.googletag = window.googletag || { cmd: [] };

    window.googletag.cmd.push(() => {
      // Define all ad slots
      window.googletag
        .defineSlot(
          "/23203048013/SearchTop970x90",
          [970, 90],
          "div-gpt-ad-1743150662964-0"
        )
        .addService(window.googletag.pubads());
      window.googletag
        .defineSlot(
          "/23203048013/SearchBetweenInventory970x250",
          [970, 250],
          "div-gpt-ad-1743150953244-0"
        )
        .addService(window.googletag.pubads());

      window.googletag
        .defineSlot(
          "/23203048013/SearchBetweenInventory728x90",
          [728, 90],
          "div-gpt-ad-1743151047455-0"
        )
        .addService(window.googletag.pubads());
      window.googletag
        .defineSlot(
          "/23203048013/SearchSideBar300x600",
          [300, 600],
          "div-gpt-ad-1743151189653-0"
        )
        .addService(window.googletag.pubads());
      window.googletag
        .defineSlot(
          "/23203048013/SearchSideBar300x250",
          [300, 250],
          "div-gpt-ad-1743151320186-0"
        )
        .addService(window.googletag.pubads());

      window.googletag
        .defineSlot(
          "/23203048013/search_page_top/Search-Page-Mobile",
          [
            [320, 50],
            [320, 100],
            [320, 250],
          ],
          "div-gpt-ad-1740120362045-0"
        )
        .addService(window.googletag.pubads());

      // Enable ads
      window.googletag.pubads().enableSingleRequest();
      window.googletag.enableServices();

      // Display all ads
      window.googletag.display("div-gpt-ad-1743150662964-0"); // Top Ad
      window.googletag.display("div-gpt-ad-1743150953244-0"); // Between Ad
      window.googletag.display("div-gpt-ad-1743151047455-0"); // Between Ad
      window.googletag.display("div-gpt-ad-1743151189653-0"); // Side Bar Ad
      window.googletag.display("div-gpt-ad-1743151320186-0"); // Side Bar Ad
      window.googletag.display("div-gpt-ad-1740120362045-0"); // Mobile Ad
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>
          {`${selectedMake ? selectedMake : "Used"} ${
            selectedModel ? selectedModel : "Cars"
          } in ${selectedCity ? selectedCity : "Pakistan"} | Famewheels`}
        </title>
        <meta
          name="description"
          content={`Find ${selectedMake ? selectedMake : "Used"} ${
            selectedModel ? selectedModel : "Cars"
          } for sale in ${
            selectedCity ? selectedCity : "Pakistan"
          } with Famewheels you can buy a used car with a few easy steps and also bid on your favorite car or post free ads and find the best condition car.| Famewheels`}
        />
        <meta
          property="og:title"
          content={
            selectedMake
              ? `${selectedMake} cars in ${
                  selectedCity ? selectedCity : "pakistan"
                } | Famewheels`
              : selectedCity
              ? `Cars for sale in ${selectedCity} | Famewheels`
              : `Used cars for sale in Pakistan | Famewheels`
          }
        />
        <meta
          property="og:description"
          content={
            selectedCity
              ? `Find a used Cars for sale in ${selectedCity} with Famewheels you can buy a used car with a few easy steps and also bid on your favorite car or post free ads and find the best condition car.| Famewheels`
              : "Discover top deals on used cars for sale in Pakistan with FameWheels. Our expert inspections guarantee the quality and reliability of each vehicle. Find your ideal used car in Pakistan today."
          }
        />

        <meta property="og:url" content={window.location.href} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content={
            selectedMake
              ? `${selectedMake} cars in ${
                  selectedCity ? selectedCity : "pakistan"
                } | Famewheels`
              : selectedCity
              ? `Cars for sale in ${selectedCity} | Famewheels`
              : `Used cars for sale in Pakistan | Famewheels`
          }
        />
        <meta
          name="twitter:description"
          content={
            selectedCity
              ? `Find a used Cars for sale in ${selectedCity} with Famewheels you can buy a used car with a few easy steps and also bid on your favorite car or post free ads and find the best condition car.| Famewheels`
              : "Discover top deals on used cars for sale in Pakistan with FameWheels. Our expert inspections guarantee the quality and reliability of each vehicle. Find your ideal used car in Pakistan today."
          }
        />

        <meta property="og:type" content="article" />
        <meta
          property="description"
          content={
            selectedCity
              ? `Find a used Cars for sale in ${selectedCity} with Famewheels you can buy a used car with a few easy steps and also bid on your favorite car or post free ads and find the best condition car.| Famewheels`
              : "Discover top deals on used cars for sale in Pakistan with FameWheels. Our expert inspections guarantee the quality and reliability of each vehicle. Find your ideal used car in Pakistan today."
          }
        />
      </Helmet>
      <div className=" colorBg_new d-none d-lg-block "></div>

      <div className="container d-none d-lg-block text-center pt-3 pb-2 trasnsitionAll ">
        {/* Search Page Top Ad */}
        <div
          className="mb-4"
          id="div-gpt-ad-1743150662964-0"
          style={{
            minWidth: "970px",
            minHeight: "90px",
          }}
        ></div>
        <Sidebar
          vehicleCategory={vehicleCategory}
          onCategoryChange={handleCategoryChange}
          selectedFilters={filters}
          onFilterChange={handleFilterChange}
        />
      </div>

      <div className="used_main text-center p-5 d-none">
        <div className="container h-100 d-flex justify-content-end align-items-center">
          <h3>Search Cars In Pakistan</h3>
        </div>
      </div>

      <div className="d-block d-lg-none">
        <Sidebar
          vehicleCategory={vehicleCategory}
          onCategoryChange={handleCategoryChange}
          selectedFilters={filters}
          onFilterChange={handleFilterChange}
        />
      </div>
      <div className="filter_main">
        <div className="mt-3">
          <div className="container  justify-content-start align-items-center mb-4">
            <h1 className=" filtersHead  fw-600 mb-0">
              {freeAdCount} Used {selectedMake ? selectedMake : "Cars"} for Sale
              in {selectedCity ? `${selectedCity}, Pakistan` : "Pakistan"}
            </h1>
            <p className="filter_main_info">
              Looking to{" "}
              <Link to={`/ad-category`}> Sell your car in Pakistan</Link>{" "}
              instead? Post an ad on FameWheels and sell your car in Pakistan
              for FREE.
            </p>
          </div>
        </div>
        <div className="container">
          <div className="row mb-5 mt-2">
            <div className="col-lg-9 col-12">
              <AdsResult
                selectedCategory={selectedCategory}
                postData={postData}
                featuredData={featuredData}
                fetchData={handleRecall}
                loading={loading}
              />
              <Pagination
                count={totalPages}
                page={page}
                onChange={handleChange}
                color="secondary"
              />
            </div>
            <div
              className="col-lg-3 col-12 d-none d-md-block position-relative"
              // style={{ zIndex: -1 }}
            >
              <div
                className="  "
                style={{
                  height: 900,
                  // position: "sticky",
                  top: 150,
                  // zIndex: -2,
                }}
              >
                {/* Search Page Side Bar Ad */}
                <div
                  id="div-gpt-ad-1743151189653-0"
                  style={{
                    minHeight: "600px",
                    minWidth: "300px",
                  }}
                ></div>
                <div
                  id="div-gpt-ad-1743151320186-0"
                  className="mt-3"
                  style={{
                    minHeight: "2500px",
                    minWidth: "300px",
                  }}
                ></div>
                <ins
                  className="adsbygoogle"
                  style={{
                    display: "inline-block",
                    width: "300px",
                    height: "800px",
                  }}
                  data-ad-client="ca-pub-3390551153563969"
                  data-ad-slot="2905132142"
                ></ins>
              </div>
            </div>
          </div>
          {/* Search Page Mobile Ad */}
          <div
            id="div-gpt-ad-1740120362045-0"
            style={{ minHeight: "50px" }}
          ></div>
        </div>
      </div>
    </>
  );
}
